import {Module} from "const/Module"

export default {
  [Module.dashboard]: "Dashboard",
  [Module.company]: 'Company',
  [Module.person]: 'Person',
  [Module.invoice]: 'Invoice',
  [Module.product]: 'Product',

  [Module.user]: 'My account',
  [Module.userMyAccount]: 'My account',

  [Module.client]: 'Company details',
  [Module.clientMyAccount]: 'Company details',

  [Module.system]: 'System settings',
  [Module.systemSettings]: 'System settings',

  [Module.imapSync]: 'imapSync',

  [Module.invoiceDefaultSettings]: 'General',
  [Module.invoiceNumberSettings]: 'Invoice number',
  [Module.invoicePrintTemplateSettings]: 'Print template',

  [Module.layout]: 'Layout',

  [Module.addressType]: 'addressType',
  [Module.phoneNumberType]: 'phoneNumberType',
  [Module.emailAddressType]: 'emailAddressType',

  [Module.address]: 'address',
  [Module.bankAccount]: 'bankAccount',
  [Module.businessNumbers]: 'businessNumbers',
  [Module.companyContactPerson]: 'companyContactPerson',
  [Module.companyRelationCompany]: 'companyRelationCompany',
  [Module.dossier]: 'dossier',
  [Module.dossierNote]: 'dossierNote',
  [Module.emailAddress]: 'emailAddress',
  [Module.personNumbers]: 'personNumbers',
  [Module.phoneNumber]: 'phoneNumber',
}
